import React from 'react'
import t from 'prop-types'
import Avatar from '../../Avatar'

const PillarContributors = ({ data }) => {
  data.siteUsers = data.siteUsers.map(user => {
    try {
      return JSON.parse(user)
    } catch (e) {
      return user
    }
  })
  return (
    <>
      <div className="pillar-contributors mt-16 lg:mt-20 mb-24 lg:mb-32 px-5 lg:px-0 max-w-screen-md mx-auto">
        {data.label && (
          <div className="uppercase tracking-spacious text-sm font-bold leading-tight text-gray-700 mb-6">
            {data.label}
          </div>
        )}
        {data.siteUsers &&
          data.siteUsers.constructor(
            <div className="flex flex-col gap-6">
              {data.siteUsers.map(item => {
                let avatarData = {
                  isSmall: true,
                  image: {
                    alt: item.image.alt,
                    src: item.image.sizes.thumbnail,
                    width: item.image.sizes['thumbnail-width'],
                    height: item.image.sizes['thumbnail-height'],
                  },
                  name: item.name,
                  role: item.role,
                }

                return <Avatar {...avatarData}></Avatar>
              })}
            </div>
          )}
      </div>
    </>
  )
}

PillarContributors.propTypes = {
  data: t.object,
}

PillarContributors.defaultProps = {}

export default PillarContributors
